'use client';

import breakpoints from '@carvana/merch-tailwind/breakpoints';
import { appAssetsCdnUrl } from '~/constants/environment';
import { GoldText } from './Hero.styles';

export default function NewCarsHero() {
  const heroBackgroundDesktopSrc = `${appAssetsCdnUrl}/images/new-car/hero-new-desktop.svg`;
  const heroBackgroundMobileSrc = `${appAssetsCdnUrl}/images/new-car/hero-new-mobile.svg`;

  return (
    <section
      className="relative h-[149px] overflow-hidden bg-background-weak md:h-[258px]"
      data-testid="hero"
    >
      <picture aria-hidden="true">
        <source
          media={`(min-width: ${breakpoints.md}px)`}
          srcSet={heroBackgroundDesktopSrc}
        />
        <img
          alt=""
          className="absolute inset-0 size-full object-cover object-[center_bottom]"
          src={heroBackgroundMobileSrc}
        />
      </picture>
      <div className="relative z-10 flex h-full items-center justify-center px-2xl">
        <h1 className="text-center text-text-inverse t-brand-sm md:t-brand-lg">
          DISCOVER <GoldText>NEW CARS</GoldText>
          <br />
          AT CARVANA
        </h1>
      </div>
    </section>
  );
}
